import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import Loader from 'Components/Forms/Loader';
import SearchToolbar from 'Components/Forms/SearchToolbar';
import React, { FC, Fragment, useState } from 'react';
import { IComponentItem } from 'FeatureModules/ComponentChain/types/component.types';
import ComponentItemTable from './ComponentItemsTable';
import { EComponentItemTableColumnKeys } from '../utils/headerColumns';
import useComponentItems from 'FeatureModules/ComponentChain/hooks/useComponentItems';
import EmptySearch from 'Components/EmptySearch';
import ErrorState from 'Components/ErrorState';
import InfiniteScrollWrapper from 'Components/InfiniteScrollWrapper';

const SearchbarContainer = styled(Box)(() => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  top: -35,
  left: 0,
  zIndex: 9,
}));

interface IComponentSelectorProps {
  selectedComponent?: IComponentItem;
  setSelectedComponent: (value: IComponentItem) => void;
}

const ComponentSelector: FC<IComponentSelectorProps> = ({
  selectedComponent,
  setSelectedComponent,
}) => {
  // Using custom search, and not the one from usePartner, because we don't want it in the query params
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { components, loading, error, hasNextPage, handlePageEndReached } = useComponentItems({
    defaultSearchTerm: searchTerm,
  });

  if (error) return <ErrorState />;
  else if (!components && loading) return <Loader />;

  return (
    <Fragment>
      <Box position="relative" mt={7} mb={3}>
        <SearchbarContainer>
          <SearchToolbar
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            data-testid="component-search-input"
            placeholder="Search components"
            className="search-input"
          />
        </SearchbarContainer>
        <InfiniteScrollWrapper hasMore={hasNextPage} next={handlePageEndReached}>
          <ComponentItemTable
            hideHeader
            components={components}
            selected={selectedComponent}
            onSelect={setSelectedComponent}
            columns={[EComponentItemTableColumnKeys.TITLE, EComponentItemTableColumnKeys.PARTNER]}
          />
        </InfiniteScrollWrapper>
      </Box>
      {!components.length && <EmptySearch />}
    </Fragment>
  );
};

export default ComponentSelector;
